import { render, staticRenderFns } from "./MagazzinoArticoliListPage.vue?vue&type=template&id=36fb7f16"
import script from "./MagazzinoArticoliListPage.vue?vue&type=script&lang=js"
export * from "./MagazzinoArticoliListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports